// Not generated from samples: written from
// Appboy::Communication::Segment::LastOrderPlacedCalculatedAttributeFilter.

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastOrderPlacedCalculatedAttributeFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_order_placed_calculated_attribute_filter"),
  // Constants::Comparisons.date_comparisons: more than / less than (a number of days ago) and
  // after / before (a date).
  comparison_key: z.enum(["3", "4", "5", "6"]),
  display_name: z.string(),
  // Only present when the filters_include_raw_values feature flipper is on.
  raw_value: z.union([z.int(), z.string()]).optional(),
  // A number of days for the interval comparisons, a date string otherwise (the field is
  // Integer | String).
  value: z.union([z.int(), z.string()]),
  varies_by_app_group: z.literal(true),
});
